<template>
    <base-modal @close="$emit('close')">
        <div
            slot="header"
            class="h3"
        >
            <template v-if="programme.id">
                Programme {{ params.nom }}
            </template>
            <template v-else>
                Ajout d'un programme
            </template>
        </div>

        <div slot="body">
            <form @submit.prevent="save">
                <div class="row">
                    <div class="col-4">
                        <base-input
                            v-model="params.nom"
                            :errors="errors.nom"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                            @keyup="params.nom = params.nom.toUpperCase()"
                        >
                            Nom*
                        </base-input>
                    </div>

                    <div class="col-4">
                        <base-input
                            v-model="params.nbr_lots_previsionnel"
                            :errors="errors.nbr_lots_previsionnel"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Nombre de lots prévisionnel
                        </base-input>
                    </div>

                    <div class="col-4">
                        <base-select
                            v-model="params.is_actif"
                            :options="optionsOuiNon"
                            :errors="errors.is_actif"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Actif
                        </base-select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <base-input
                            v-model="params.adresse"
                            :errors="errors.adresse"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Adresse
                        </base-input>
                    </div>

                    <div class="col-4">
                        <base-input
                            v-model="params.ville"
                            :errors="errors.ville"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Ville
                        </base-input>
                    </div>

                    <div class="col-4">
                        <base-input
                            v-model="params.code_postal"
                            :errors="errors.code_postal"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Code postal
                        </base-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <base-input
                            v-model="params.pays"
                            :errors="errors.pays"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Pays
                        </base-input>
                    </div>

                    <div class="col-4">
                        <base-select
                            v-model="params.responsable_tva_equipe_id"
                            :errors="errors.responsable_tva_equipe_id"
                            :options="optionsResponsablesTva"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Responsable TVA
                        </base-select>
                    </div>

                    <div class="col-4">
                        <base-select
                            v-model="params.programme_type"
                            :errors="errors.programme_type"
                            :options="optionsProgrammeType"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Type du programme*
                        </base-select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <base-input
                            v-model="params.nom_gestionnaire"
                            :errors="errors.nom_gestionnaire"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Nom du gestionnaire
                        </base-input>
                    </div>

                    <div class="col-4">
                        <base-select
                            v-model="params.financement_ht"
                            :options="addEmptyOption(optionsOuiNon)"
                            :errors="errors.financement_ht"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            Financement HT
                        </base-select>
                    </div>

                    <div
                        v-if="params.financement_ht === 1"
                        class="col-4"
                    >
                        <base-select
                            v-model="params.responsable_ht_id"
                            :options="optionsResponsablesTva"
                            :errors="errors.responsable_ht_id"
                            :readonly="readonly || isCreateLots"
                        >
                            Responsable financement HT
                        </base-select>
                    </div>

                    <div class="col-4">
                        <base-select
                            v-model="params.tva_solde"
                            :options="optionsOuiNon"
                            :errors="errors.tva_solde"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                        >
                            TVA soldé
                        </base-select>
                    </div>

                    <base-input
                        v-model="params.date_acte_estimee"
                        :errors="errors.date_acte_estimee"
                        :readonly="readonly"
                        :disabled="readonly || isCreateLots"
                        class="col-4"
                        type="date"
                    >
                        Date d'acte estimée
                    </base-input>

                    <base-input
                        v-model="params.date_livraison_estimee"
                        :errors="errors.date_livraison_estimee"
                        :readonly="readonly"
                        :disabled="readonly || isCreateLots"
                        class="col-4"
                        type="date"
                    >
                        Date de livraison estimée
                    </base-input>

                    <div
                        v-if="params.programme_type === 'Résidence de service'"
                        class="col-4"
                    >
                        <base-select
                            v-model="params.promoteur_id"
                            :options="[{label: '', value: null}]"
                            src="/api/promoteurs/autocomplete"
                            :fetched="fetchedPromoteur"
                            :readonly="readonly"
                            :disabled="readonly || isCreateLots"
                            @input="clearNewPromoteur"
                        >
                            Promoteur
                        </base-select>
                    </div>
                </div>

                <div v-if="params.programme_type === 'Résidence de service' && !params.promoteur_id && !isCreateLots">
                    <div class="h4 category-header">
                        Ajouter un promoteur
                    </div>

                    <div class="row justify-content-center">
                        <base-input
                            v-model="params.new_promoteur.nom"
                            :errors="errors['new_promoteur.nom']"
                            :disabled="readonly"
                            class="col-4"
                        >
                            Nom*
                        </base-input>

                        <base-input
                            v-model="params.new_promoteur.mail"
                            :errors="errors['new_promoteur.mail']"
                            :disabled="readonly"
                            class="col-4"
                        >
                            Adresse mail*
                        </base-input>

                        <base-input
                            v-model="params.new_promoteur.telephone"
                            :errors="errors['new_promoteur.telephone']"
                            :disabled="readonly"
                            class="col-4"
                        >
                            Numéro de téléphone*
                        </base-input>
                    </div>
                </div>

                <div v-if="!isCreateLots">
                    <div class="h4 category-header">
                        Notaire
                    </div>

                    <div class="row">
                        <base-input
                            v-model="params.notaire_nom"
                            :errors="errors['notaire_nom']"
                            :disabled="readonly"
                            class="col-4"
                        >
                            Nom notaire
                        </base-input>

                        <base-input
                            v-model="params.notaire_adresse"
                            :errors="errors['notaire_adresse']"
                            :disabled="readonly"
                            class="col-4"
                        >
                            Adresse
                        </base-input>

                        <base-input
                            v-model="params.notaire_code_postal"
                            :errors="errors['notaire_code_postal']"
                            :disabled="readonly"
                            class="col-4"
                        >
                            Code Postal
                        </base-input>
                    </div>

                    <div class="row">
                        <base-input
                            v-model="params.notaire_ville"
                            :errors="errors['notaire_ville']"
                            :disabled="readonly"
                            class="col-4"
                        >
                            Ville
                        </base-input>

                        <base-input
                            v-model="params.notaire_telephone"
                            :errors="errors['notaire_telephone']"
                            :disabled="readonly"
                            class="col-4"
                        >
                            Numéro de téléphone
                        </base-input>
                    </div>
                </div>

                <div class="h4 category-header">
                    Gestion des Lots
                </div>
                <base-error :errors="errors.lots" />


                <div class="h6 mb-0">
                    Rechercher par :
                </div>
                <div class="row mb-4">
                    <div class="col-6">
                        <base-input v-model="lotSearchParams.identifiant_externe">
                            Identifiant Externe
                        </base-input>
                    </div>
                    <div class="col-6">
                        <base-input v-model="lotSearchParams.reference">
                            Référence
                        </base-input>
                    </div>
                </div>

                <div v-if="optionsLotType">
                    <div
                        v-for="(lot, index) in displayLots.slice((page - 1) * nbPerPage, page * nbPerPage)"
                        :key="index"
                    >
                        <div class="row">
                            <div class="col-3">
                                <base-input
                                    v-model="lot.reference"
                                    :errors="errors[`lots.${index}.reference`]"
                                    :readonly="readonly"
                                    :disabled="(readonly || (isCreateLots && lot.id))"
                                >
                                    Référence*
                                </base-input>
                            </div>

                            <div
                                v-if="isMultipleLotType"
                                class="col-4"
                            >
                                <base-select
                                    v-model="lot.lot_type"
                                    :errors="errors[`lots.${index}.lot_type`]"
                                    :options="optionsLotType"
                                    :readonly="readonly"
                                    :disabled="(readonly || (isCreateLots && lot.id))"
                                >
                                    Type du lot
                                </base-select>
                            </div>
                            <div
                                v-else
                                class="col-4"
                            >
                                <base-input
                                    :disabled="true"
                                    :value="optionsLotType[0].value"
                                />
                            </div>

                            <div class="col-3">
                                <base-input
                                    v-model="lot.identifiant_externe"
                                    :errors="errors[`lots.${index}.identifiant_externe`]"
                                    :readonly="readonly"
                                    :disabled="me.id !== 1 || readonly || (isCreateLots && lot.id)"
                                >
                                    Identifiant externe
                                </base-input>
                            </div>

                            <div class="col-2">
                                <div class="form-group">
                                    <button
                                        type="button"
                                        class="btn btn-primary ml-2"
                                        title="Aller sur le dossier"
                                        @click.stop="navigateToDossier(lot.id)"
                                    >
                                        <i class="fa fa-glasses" />
                                    </button>
                                    <button
                                        v-if="!readonly"
                                        type="button"
                                        class="btn btn-danger"
                                        title="Supprimer le lot"
                                        :disabled="(readonly || (isCreateLots && lot.id))"
                                        @click.stop="removeLot(lot.id)"
                                    >
                                        <i class="fas fa-trash" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <BasePaginate
                        v-if="params.lots.length > nbPerPage"
                        :current-page="page"
                        :last-page="lastPageLot"
                        @change-page="page = $event"
                    />
                    <button
                        v-if="!readonly"
                        type="button"
                        class="btn btn-sm btn-primary mr-2 mt-4"
                        title="Ajouter un lot"
                        @click.stop="addLot"
                    >
                        Ajouter un lot
                    </button>
                </div>
                <div v-else>
                    Veuillez choisir un type de programme valide
                </div>
            </form>
        </div>

        <div slot="footer">
            <button
                v-if="!readonly"
                v-btn-loading="saving"
                class="btn btn-success mr-2"
                @click="save"
            >
                Enregistrer
            </button>

            <button
                class="btn btn-danger"
                @click="$emit('close')"
            >
                {{ readonly ? 'Fermer' : 'Annuler' }}
            </button>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import BaseInput from "../templates/BaseInput"
    import BaseSelect from "../templates/BaseSelect"
    import BaseError from "../templates/BaseError"
    import BasePaginate from "../templates/BasePaginate"
    import {mapGetters } from "vuex"

    export default {
        name: "ProgrammeEditModal",

        components: { BaseInput, BaseSelect, BaseModal, BaseError, BasePaginate },

        props: {
            programme: { type: Object, default: () => {} },
            isLotClient: Boolean,
            isCreateLots: { type: Boolean, default: false },
            readonly: Boolean
        },

        data: function () {
            return {
                params: _.cloneDeep( this.programme ),
                errors: {},
                saving: false,
                selectPromoteur: true,

                optionsOuiNon: [
                    { value: 1, label: 'Oui' },
                    { value: 0, label: 'Non' },
                ],
                nbPerPage: 6,
                page: 1,
                lotSearchParams: {},
            }
        },

        computed: {

            ...mapGetters(['optionsLocationType', 'optionsProgrammeType', 'me']),

            fetchedPromoteur: function() {
                if(this.programme.promoteur)
                    return [{label: this.programme.promoteur.nom, value: this.programme.promoteur.id}]
                return []
            },

            optionsResponsablesTva: function () {
                return [{label: '', value: null}, ...this.$store.getters.optionsEquipes]
            },

            optionsLotType: function (){
                let programmeType = this.optionsProgrammeType
                    .find(element => element.label === this.params.programme_type)

                return programmeType ?
                    programmeType.lotTypes :
                    null
            },
            isMultipleLotType: function (){
                return this.optionsLotType ?
                    this.optionsLotType.length > 1:
                    null
            },
            lastPageLot: function () {
                return Math.ceil(this.displayLots.length/this.nbPerPage)
            },
            displayLots: function () {
                return this.params.lots
                    .filter((lot) =>
                        (!this.lotSearchParams.identifiant_externe || (lot.identifiant_externe && lot.identifiant_externe.includes(this.lotSearchParams.identifiant_externe))) &&
                        (!this.lotSearchParams.reference ||( lot.reference && lot.reference.includes(this.lotSearchParams.reference)))
                    )
            },
        },

        watch: {
            'params.financement_ht': function (value) {
                if (!value) {
                    this.params.responsable_ht_id = null
                }
            },
            'params.programme_type': function (){
                let newValue = this.isMultipleLotType ?
                    null :
                    this.optionsLotType[0].value

                this.params.lots.forEach(lot => {
                    lot.lot_type = newValue
                })
            }
        },

        created: function() {
            this.initLot()
            this.clearNewPromoteur()
        },

        methods: {
            /**
             * Enregistre le programme
             */
            save: async function () {
                this.saving = true

                try {
                    const response = await axios.request({
                        url: '/api/programmes' + (this.programme.id ? '/' + this.programme.id : ''),
                        method: this.programme.id ? 'patch' : 'post',
                        data: {...this.params, 'promoteur_is_required': this.programme.id ? !this.isCreateLots : false }
                    })
                    await this.saved(response.data.id)
                } catch (error) {
                    if (error.response && error.response.data.errors) {
                        this.errors = error.response.data.errors
                    } else {
                        this.$notify('danger', 'Une erreur est survenue lors de la mise à jour du programme.')
                    }
                } finally {
                    this.saving = false
                }
            },

            /**
             * callback si le programme a bien été sauvegardé
             */
            saved: async function (programme_id) {
                if (!this.isLotClient) {
                    this.$emit('reload')
                } else {
                    this.$emit('select', (await axios.get(`/api/programmes/${programme_id}`)).data.data)
                }

                this.$notify('success', 'Le programme a bien été enregistré.')
                this.$emit('close')
            },

            /**
             * Ajout une option vide
             * @param options Array
             * @return Array
             */
            addEmptyOption: function (options) {
                return [{value: '', label: ''}].concat(options)
            },

            initLot() {
                if (!this.params.lots || !(this.params.lots.length > 0)) {
                    this.params = Object.assign({}, this.params,{ lots: [] })
                }
                if (this.isCreateLots) {
                    this.addLot()
                }
            },

            addLot: function () {
                if(this.params.programme_type){
                    this.params.lots.push(
                        { reference: null, lot_type: null, identifiant_externe: null }
                    )
                    this.page = this.lastPageLot
                    return
                }
                this.errors = {...this.errors, programme_type: ["Veuillez renseigner le type du programme pour ajouter un nouveau lot"] }
                this.$notify('danger', 'Le type du programme doit être renseigné pour ajouter un lot.')
                this.$emit('close')
            },

            removeLot: function(id) {
                const index = this.params.lots.findIndex((item) => item.id === id)
                let lot = this.params.lots[index]
                if (!lot.id) {
                    return this.params.lots.splice(index, 1)
                }

                this.$confirm('Êtes-vous certain de vouloir supprimer ce lot ?').then(() => {
                    axios.delete(`/api/lot/${lot.id}`)
                        .then(() => {
                            this.$notify('success', 'Le lot a bien été supprimé.')
                            this.params.lots.splice(index, 1)
                            if (!this.params.lots.length) {
                                this.addLot()
                            }
                        })
                        .catch((error) => {
                            if (error.response && error.response.data.message) {
                                this.errors = { lots: [error.response.data.message] }
                            } else {
                                this.$notify('danger', 'Une erreur est survenue lors de la mise à jour du programme.')
                            }
                        })
                })
            },

            clearNewPromoteur: function() {
                this.params.new_promoteur = { nom: null, mail: null, telephone: null }
            },

            navigateToDossier: function ($lot) {
                axios.get(`/api/dossiers/by-lot/${$lot}`).then((response) => {
                    this.$router.push({name: 'dossier', params: {id: response.data.data.id}})
                }).catch(() => {
                    this.$notify('danger', 'Impossible de trouver le dossier')
                })
            },
        },
    }
</script>

<style>
.category-header {
    border-bottom: 1px solid black;
    margin-top: 17px;
    margin-bottom: 25px !important
}
</style>
